<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
    import OverlayBoxHeader from './OverlayBoxHeader.svelte';
    import { __ } from '@oat-sa-private/ui-core';

    const closeButton = {
        key: 'close',
        label: __('close'),
        icon: 'remove'
    };

    /**
     * @typedef {Object} ButtonProps
     * @property {String} key
     * @property {String} label
     * @property {String} icon - icon name without size suffix
     */
    /**
     * Box component, with slot and configurable header
     * For use in modal or inline contexts
     * @property {ButtonProps[]} startActions - props for IconBarButtons (left)
     * @property {ButtonProps[]} endActions - props for IconBarButtons (right)
     * @property {String} heading
     * @property {Number} headingLevel - from 1 to 6
     * @property {Boolean} inverted - affects header bar style
     * @property {String} width - must be a valid CSS width
     */
    export let startActions = [closeButton];
    export let endActions = [];
    export let heading = '';
    export let headingLevel = 2;
    export let inverted = false;
    export let width;
    export let height;
    export let ariaModal = false;
    export let ariaLabel;

    $: style = width || height ? `${width ? `width:${width};` : ''}${height ? `height:${height};` : ''}` : null;
</script>

<style>
    .overlay-box {
        border: var(--border-medium) solid var(--color-border-default);
        background-color: var(--color-bg-default);
        z-index: var(--layer-4);

        &:focus {
            outline: none;
        }
    }

    .overlay-box-content {
        padding: 2rem;
    }

    .fixed-height {
        height: calc(100% - 6rem);
        overflow: auto;
    }
</style>

<div
    class="overlay-box"
    role="dialog"
    tabindex="-1"
    aria-modal={!!ariaModal}
    aria-label={ariaLabel ? ariaLabel : void 0}
    {style}>
    <OverlayBoxHeader {startActions} {endActions} {heading} {headingLevel} {inverted} on:action />
    <div class="overlay-box-content" class:fixed-height={!!height}>
        <slot />
    </div>
</div>
